(window.Apsiyon ? window.Apsiyon.ver    = '0.1.0' : window.Apsiyon = {ver:    '0.1.0'}); // jshint ignore:line